import React from "react";

// PMN node-network mark — teal source node linked to two nodes.
// `tone` sets the non-teal nodes/links (charcoal on light, paper on dark).
export function PmnLogo({ size = 30, tone = "#1F2024", className = "" }) {
  return (
    <svg
      viewBox="0 0 800 800"
      width={size}
      height={size}
      className={className}
      aria-label="Project Management Network"
      role="img"
    >
      <line x1="165" y1="190" x2="588" y2="186" stroke={tone} strokeWidth="52" strokeLinecap="round" />
      <line x1="165" y1="190" x2="588" y2="600" stroke={tone} strokeWidth="52" strokeLinecap="round" />
      <circle cx="588" cy="186" r="100" fill={tone} />
      <circle cx="588" cy="600" r="100" fill={tone} />
      <circle cx="165" cy="190" r="100" fill="#0E7490" />
    </svg>
  );
}
